import styled from 'styled-components';
import { normalizeWidth } from '../../utils/normalize';

export const Container = styled.div`
  align-items: center;
  display: flex;
  width: 100%;
  height: 66px;
  z-index: 100;
  position: fixed;
`;

export const LogoWrapper = styled.div`
  max-width: 88px;
  height: 100%;
  cursor: pointer;
`;

export const InnerContainer = styled.div`
  display: flex;
  height: 48px;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
`;

export const HeaderLinksContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  align-items: center;
  justify-content: center;
`;

export const HeaderLink = styled.div`
  color: #1B1B1B;
  cursor: pointer;
  font-family: Inter-Regular;
  font-size: 16px;
  font-weight: 500;
`;

export const SearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 30px;
  border-radius: 8px;
  padding-left: 16px;
  padding-right: 16px;
`;

export const SearchInput = styled.input`
  height: 30px;
  background-color: #D9D9D9;
  border: none;
  font-family: Inter-Regular;
  font-size: 16px;
  font-weight: 400;
  line-height: 125%;
  color: #000;
  background-color: #D9D9D9;
  &:placeholder {
    color: #FFF;
  }
  color: #FFF;

  &:focus {
    border: none;
    outline: none;
  }
  &:active {
    border: none;
    outline: none;
  }
`;

export const FormContainer = styled.form`
  width: 355px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  background-color: #D9D9D9;
`;

export const SearchIconWrapper = styled.div`
  cursor: pointer;
  margin-right: 8px;
`;

export const CreateProjectButton = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 30px;
  cursor: pointer;
  color: #FFF;
  font-size: 16px;
`;

export const IconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  justify-content: center;
`;

export const Icon = styled.div`
  height: 31px;
  width: 31px;
  cursor: pointer;
`;